import { MODIFY,ERROR,LOADING,CHANGE,OPEN_MODAL} from "./actions";

const initialState = {
 modifyRate:null,
 error:null,
 loading:false,
 rate:null,
 isOpen:false
};

const improveRateReducer = (state = initialState, action) => {
  const { type, modifyRate, error ,loading,rate,isOpen} = action;
  
  switch (type) {
    case MODIFY:
      return { ...state, modifyRate};
    case ERROR:
        return { ...state, error};           
    case LOADING:
      return { ...state, loading}
    case CHANGE:
      return { ...state, rate} 
    case OPEN_MODAL:
        return { ...state, isOpen}                     
    default:
      return state;
  }
};

export default improveRateReducer;
